// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1PfCW","shadow":"style_shadow__2U5WP"};